import React from "react";

import {
    BoxHeader,
    BoxMenuContainer,
    BoxMenuItem,
    BoxMenuItemText,
    Container,
    ContainerBox,
    NewButton
} from "./style";
import { Panel } from "../../../interfaces/Panel";
import { FaPlus, FaPen } from "react-icons/fa";
import { ClickAwayListener } from "@material-ui/core";
import NewPanel from "../NewPanel";
import EditPanel from "../EditPanel";

interface MenuPageProps {
    flow_id: number;
    open?: boolean;
    setOpen?: (open: boolean) => void;
    panels?: Panel[];
    selectedPanel?: Panel;
    setSelectedPanel?: (panel: Panel) => void;
    refreshPanels?: (selectId?: number) => void;
}

const MenuPage: React.FC<MenuPageProps> = ({ flow_id, open, setOpen, panels, selectedPanel, setSelectedPanel, refreshPanels }) => {

    const [openNewPage, setOpenNewPage] = React.useState<boolean>(false);
    const [panelEditing, setPanelEditing] = React.useState<Panel | undefined>(undefined);

    const handleClickAway = () => {
        if (setOpen) {
            setOpen(false);
        }
    };

    const handleCloseNewPage = (withRefresh?: boolean, selectId?: number) => {
        setOpenNewPage(false);

        if (setOpen) {
            setOpen(false);
        }

        if (withRefresh) {
            if (refreshPanels) {
                refreshPanels(selectId);
            }
        }

    };

    const handleCloseEditPage = (withRefresh?: boolean, selectId?: number) => {
        setPanelEditing(undefined);

        if (withRefresh) {
            if (refreshPanels) {
                refreshPanels(selectId);
            }
        }
    };

    return (
        <ClickAwayListener onClickAway={handleClickAway}>
            <Container>
                <ContainerBox style={{ padding: '10px', position: 'relative' }}>
                    <BoxHeader>
                        Páginas
                    </BoxHeader>

                    <NewButton onClick={() => {
                        setOpenNewPage(true);
                    }}>
                        <FaPlus />
                        Nova Página
                    </NewButton>

                    {openNewPage && (
                        <NewPanel
                            open={openNewPage}
                            flow_id={flow_id}
                            onClose={handleCloseNewPage}
                        />
                    )}

                    {panelEditing && (
                        <EditPanel
                            open={panelEditing !== undefined}
                            panel={panelEditing}
                            onClose={handleCloseEditPage}
                        />
                    )}

                    <BoxMenuContainer>

                        {panels && [...panels].sort((a, b) => a.name.localeCompare(b.name, 'pt', { sensitivity: 'base' })).map((panel: Panel) => (
                            <BoxMenuItem key={panel.id_panel} isSelect={panel.id_panel === selectedPanel?.id_panel} onClick={() => {
                                if (setSelectedPanel) {
                                    setSelectedPanel(panel);
                                }
                                if (setOpen) {
                                    setOpen(false);
                                }
                            }}>
                                <BoxMenuItemText className="box-menu-item-text">
                                    {panel.name}
                                </BoxMenuItemText>

                                <div className="edit-icon" onClick={(e) => {
                                    e.stopPropagation();
                                    setPanelEditing(panel);
                                }}>
                                    <FaPen size={12} />
                                </div>
                            </BoxMenuItem>
                        ))}

                    </BoxMenuContainer>

                </ContainerBox>
            </Container>
        </ClickAwayListener >
    );

}

export default MenuPage;